<div class="busy-spinner" *ngIf="busySpinner || jsPanelSpinner" [class.jspanel-spinner]="jsPanelSpinner">
    <div class="lds-ripple">
        <div></div>
        <div></div>
    </div>
</div>

<router-outlet></router-outlet>